const sourceVariable = "SalamAir.Source"

import { storage } from "../state/ducks/session/sessionService";

export function getSource() {
  return storage.getItem(sourceVariable);
}

export function setSource(source) {
  // we change the setting only when the source has a value
  if(source)
    storage.setItem(sourceVariable, source)
}

export function isInAppBrowser() {
  const source = getSource();
  return source === 'ios' || source==='android';
}

export function isIOS() {
  const source = getSource();
  if(source) return source === 'ios';

  if (typeof navigator === 'undefined') return false;

  // iPhone/iPod and iPad on iOS 12 and below
  // !window.MSStream excludes IE11, which includes "iPhone" in its UA
  if (/iPhone|iPod|iPad/.test(navigator.userAgent) && !window.MSStream) return true;

  // iPadOS 13+ reports as Macintosh in the UA but exposes touch points
  if (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1) return true;

  return false;
}